export default "__VITE_ASSET__BaPhYgQQ__"